import React, { useEffect } from "react";

import { useMsal } from "@azure/msal-react";
import { useNavigate } from "@tanstack/react-router";

import { DEFAULT_PROTECTED_ROUTE } from "../constants/auth";
import { setAccessTokenCookie } from "../utils/cookies";
import { PageLoader } from "./PageLoader";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the redirect promise - this completes the login flow
        const response = await instance.handleRedirectPromise();

        if (response?.account) {
          // Set active account
          instance.setActiveAccount(response.account);

          // Set access token if available
          if (response.accessToken) {
            setAccessTokenCookie(response.accessToken);
          }

          // Navigate to protected route
          navigate({ to: DEFAULT_PROTECTED_ROUTE, replace: true });
        } else {
          // No response means redirect was already handled or no redirect was pending
          // Wait a bit and check if user is authenticated
          setTimeout(() => {
            const accounts = instance.getAllAccounts();
            if (accounts.length > 0) {
              instance.setActiveAccount(accounts[0]);
              navigate({ to: DEFAULT_PROTECTED_ROUTE, replace: true });
            } else {
              // If no accounts, redirect to landing page
              navigate({ to: "/", replace: true });
            }
          }, 500);
        }
      } catch (error) {
        console.error("Error handling auth callback:", error);
        // On error, redirect to landing page
        navigate({ to: "/", replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, instance]);

  return <PageLoader message="Signing in..." />;
};
